import { render, staticRenderFns } from "./CardTotal.vue?vue&type=template&id=3155f511&"
import script from "./CardTotal.vue?vue&type=script&lang=js&"
export * from "./CardTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports